var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtectShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9647 2.28788C7.41473 2.07576 5.4912 0 5.4912 0C5.4912 0 3.56767 2.07576 0.0176711 2.28788C0.0176711 2.28788 -0.611741 10.2848 5.4912 12.997C11.5941 10.2848 10.9647 2.28788 10.9647 2.28788Z",
    fill: "url(#paint0_linear_1_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0559 2.98795C7.09706 2.81219 5.49118 1.07886 5.49118 1.07886C5.49118 1.07886 3.88824 2.80916 0.926473 2.98795C0.926473 2.98795 0.400002 9.65765 5.49118 11.9213C10.5824 9.65765 10.0559 2.98795 10.0559 2.98795Z",
    fill: "url(#paint1_linear_1_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91174 3.18784C7.04409 3.01511 5.49115 1.33936 5.49115 1.33936C5.49115 1.33936 3.93821 3.01511 1.07056 3.18784C1.07056 3.18784 0.561739 9.64845 5.49115 11.8424C10.4206 9.65148 9.91174 3.18784 9.91174 3.18784Z",
    fill: "url(#paint2_linear_1_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4911 13C6.46169 12.5363 7.35875 11.8969 8.09992 11.0969C9.88816 9.17572 10.697 6.50299 10.9146 3.89693C10.9587 3.3636 10.9823 2.82421 10.9646 2.28784C11.0117 2.82421 11.0087 3.3636 10.9823 3.89996C10.8499 6.40905 10.1058 8.98481 8.44698 10.8818C7.63816 11.8121 6.61463 12.5394 5.48816 13H5.4911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8352 3.15754C7.01755 2.98784 5.49108 1.33936 5.49108 1.33936C5.49108 1.33936 3.96461 2.98784 1.14696 3.15754C1.14696 3.15754 0.646964 9.50602 5.49108 11.6606C10.3352 9.50602 9.8352 3.15754 9.8352 3.15754Z",
    fill: "url(#paint3_linear_1_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49114 1.77271C5.49114 1.77271 3.96467 3.42119 1.14702 3.59089C1.14702 3.59089 1.1382 3.69695 1.13525 3.8818C1.17055 5.60907 1.6529 9.95149 5.49114 11.6606C9.33231 9.95149 9.81466 5.60907 9.84702 3.8818C9.84408 3.69695 9.83525 3.59089 9.83525 3.59089C7.01761 3.42119 5.49114 1.77271 5.49114 1.77271Z",
    fill: "url(#paint4_linear_1_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49111 1.33946C5.32053 1.52733 5.12641 1.69097 4.92641 1.84552C4.42347 2.23037 3.86759 2.53643 3.27935 2.7637C2.80876 2.94552 2.32053 3.07582 1.82347 3.15461C1.59994 3.19097 1.37347 3.21521 1.14994 3.23037L1.22053 3.16067V3.17885C1.21759 3.2243 1.21464 3.27279 1.21464 3.31521C1.16759 5.994 1.92347 8.91218 3.99111 10.6819C4.28817 10.9364 4.60876 11.1637 4.94406 11.3607C5.12347 11.4667 5.30582 11.5637 5.49406 11.6546C5.02347 11.4637 4.57641 11.2122 4.1617 10.9122C3.8117 10.6576 3.48523 10.3637 3.19111 10.0395C1.82641 8.5334 1.2117 6.45764 1.07935 4.43643C1.05288 4.02127 1.047 3.60309 1.07053 3.18794V3.16673L1.07347 3.14552L1.07935 3.07885C2.53229 3.01521 3.97935 2.53037 5.14994 1.63037C5.26759 1.53643 5.38523 1.44249 5.49406 1.33643L5.49111 1.33946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_366",
    x1: 14.4618,
    y1: 13.8818,
    x2: 1.10105,
    y2: 1.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_366",
    x1: 6.62941,
    y1: 6.00007,
    x2: -5.1549,
    y2: 10.7099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_366",
    x1: 6.53233,
    y1: 3.57572,
    x2: 2.38365,
    y2: 9.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_366",
    x1: 1.13226,
    y1: 6.49996,
    x2: 9.84991,
    y2: 6.49996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A47927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#755017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_366",
    x1: 1.13231,
    y1: 6.71513,
    x2: 14.4647,
    y2: 6.71513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#C5A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#C7A661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F3E197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D5BE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#755017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#906926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E0BF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C5A24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4915"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectShield);
export default __webpack_public_path__ + "static/media/ProtectShield.6ff1d456959dedd7d0e47d0767d306fa.svg";
export { ForwardRef as ReactComponent };